module.exports = __webpack_public_path__ + "public/img/荣誉奖项AWARDS_EN.8781ec12.png";